export const BINANCE_PROMPT = 'BinancePrompt';
export const BINANCE_PROMPT_INVALID = 'DO NOT SHOW';
